import { useState } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router';
import { ToastProvider } from './components/toast.js';
import { ErrorBoundary } from './components/error-boundary.js';
import { createQueryClient } from './lib/query-client.js';
import { router } from './app/router.js';

/**
 * Providers, outermost first: a crash guard around everything, then server
 * state, then toasts — so a failed mutation can still announce itself even if
 * the screen under it has gone.
 */
export function App(): React.JSX.Element {
  // Created once per mount rather than at module scope, so a test can render
  // the app twice without the two sharing a cache.
  const [queryClient] = useState(createQueryClient);

  return (
    <ErrorBoundary title="Dintiko could not start">
      <QueryClientProvider client={queryClient}>
        <ToastProvider>
          <RouterProvider router={router} />
        </ToastProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}
